import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { HolidayRegion, PublicHoliday } from '../../types/team.types';
import { useAppMutation } from '../use-app-mutation.hook';

export type CreatePublicHolidayDto = {
  date: string;
  name: string;
  region: HolidayRegion;
};

// Cross-tenant admin data — not scoped to companies/:companyId; enforced server-side by AdminPanelGuard.
export const useCreatePublicHoliday = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: createHoliday, isPending } = useAppMutation(
    [QueryKey.CREATE_PUBLIC_HOLIDAY],
    {
      mutationFn: (body: CreatePublicHolidayDto) =>
        ApiService.post<PublicHoliday, CreatePublicHolidayDto>(
          { endpoint: BackendRoute.TEAM_PUBLIC_HOLIDAYS },
          { body },
        ),
      onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PUBLIC_HOLIDAYS] }),
    },
  );

  return { createHoliday, isPending };
};
